import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { errorInterceptor } from './http/error.interceptor';
import { provideGmrWebMcpTools } from './webmcp/webmcp-tools';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([errorInterceptor])),
    provideTranslateService({
      //
      // No leading slash: must resolve relative to <base href>, matching the original app's
      // document-relative asset paths, since this site can be deployed at any URL depth.
      //
      loader: provideTranslateHttpLoader({ prefix: 'assets/i18n/', suffix: '.json' }),
      fallbackLang: 'en',
    }),

    //
    // WebMCP: the catalogue and the parameter wizard as tools for an in-browser AI agent. Registered
    // on the root injector because a tool name must be unique within the document and registering the
    // same name twice throws - anything that can mount more than once would eventually do so.
    //
    // Costs nothing where the API is absent: Angular checks for document.modelContext and returns
    // without registering, so Firefox, Safari and a Chrome outside the origin trial see no change.
    // See webmcp-tools.ts for why no download tool is among them.
    //
    provideGmrWebMcpTools(),
  ]
};
